import { Box, IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react";
import AppointmentPatients from "./AppointmentPatients";
import AddAppointment from "./AddAppointment";
import TabQueueSystem from "./queue_system/TabQueueSystem";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { menuActive  } from '../../store/menuSlice';
import { useEffect } from "react";

import { GrSchedules, GrScheduleNew,GrList } from "react-icons/gr";
import { FaUserDoctor } from "react-icons/fa6";
import { PiUserList } from "react-icons/pi";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import { GoCommentDiscussion } from "react-icons/go";
import { AiOutlineOrderedList } from "react-icons/ai";

import { sxBtnSelect, sxBtnSelectA, sxBtnSelectB } from "../../components/ButtonCustomize";

export default function TabConsultDoctor() {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [value, setValue] = useState(0);
    const [appointPage, setAppointPage] = useState(0);
    const [queuePage, setQueuePage] = useState(0);

    if (!location.state) {
        location.state = { value: 0 }
    }

    useEffect(() => {
        dispatch(menuActive('ปรึกษาแพทย์/พยาบาล'))
    },[])

    return (
        <>
            <Box sx={{
                display: 'flex',
                justifyContent: 'start',
                mt: 1, mb: 2, ml: '3rem',
                '@media (max-width: 512px)': {
                    ml: 0,
                    justifyContent: 'center',
                }
            }}>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 6,
                    pr: 5,
                    '@media (max-width: 512px)': {
                        ...(value !== 1 ? {
                            gap: 0.5,
                            pr: 1.25,
                        }
                        :
                        {
                            gap: 3,
                            pr: 0,
                        })
                    }
                }}>

                    <Tooltip title="ผู้ป่วยนัด">
                        <IconButton
                            onClick={() => { setValue(0); navigate("/auth/consult_doctor", { state: { value: 0 } }); }} aria-label="ผู้ป่วยนัด" size="large" color="c_button"
                            {...(location.state.value === 0 && sxBtnSelectA)}
                        >
                            <GrSchedules/>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="เพิ่มการนัดหมาย">
                        <IconButton
                            onClick={() => { setValue(1); navigate("/auth/consult_doctor", { state: { value: 1 } }); }} aria-label="เพิ่มการนัดหมาย" size="large" color="c_button"
                            {...(location.state.value === 1 && sxBtnSelect)}
                        >
                            <GrScheduleNew/>
                        </IconButton>
                    </Tooltip>

                    { localStorage.getItem('hospital_code') !== 'N/A' && 
                        <Tooltip title="ติดต่อแพทย์/พยาบาล">
                            <IconButton
                                onClick={() => { setValue(2); navigate("/auth/consult_doctor", { state: { value: 2 } }); }} aria-label="ติดต่อแพทย์/พยาบาล" size="large" color="c_button"
                                {...(location.state.value === 2 && sxBtnSelectA)}
                            >
                                <FaUserDoctor />
                            </IconButton>
                        </Tooltip>
                    }
                    
                </Box>

                { value === 0 &&
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 6,
                        pl: 5,
                        boxShadow: "-1px 0px #E3E9F2",
                        '@media (max-width: 512px)': {
                            gap: 0.5,
                            pl: 1.25,
                        }
                    }}>

                        <Tooltip title="ผู้ป่วยนัดจากระบบ">
                            <IconButton
                                onClick={() => { setAppointPage(0); }} aria-label="ผู้ป่วยนัดจากระบบ" size="large" color="c_button"
                                {...(appointPage === 0 && sxBtnSelectB)}
                            >
                                <PiUserList/>
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="รายการที่รับคำปรึกษา">
                            <IconButton
                                onClick={() => { setAppointPage(1); }} aria-label="รายการที่รับคำปรึกษา" size="large" color="c_button"
                                {...(appointPage === 1 && sxBtnSelectB)}
                            >
                                <GrList/>
                            </IconButton>
                        </Tooltip>

                    </Box>
                }

                { value === 2 &&
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 6,
                        pl: 5,
                        boxShadow: "-1px 0px #E3E9F2",
                        '@media (max-width: 512px)': {
                            gap: 0.75,
                            pl: 1.25,
                        }
                    }}>

                        <Tooltip title="รายชื่อนัดประจำวัน">
                            <IconButton
                                onClick={() => { setQueuePage(0); }} aria-label="รายชื่อนัดประจำวัน" size="large" color="c_button"
                                {...(queuePage === 0 && sxBtnSelectB)}
                            >
                                <HiOutlineClipboardDocumentList/>
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="ซักประวัติและจัดห้อง">
                            <IconButton
                                onClick={() => { setQueuePage(1); }} aria-label="ซักประวัติและจัดห้อง" size="large" color="c_button"
                                {...(queuePage === 1 && sxBtnSelectB)}
                            >
                                <GoCommentDiscussion/>
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="แพทย์เรียกคิว">
                            <IconButton
                                onClick={() => { setQueuePage(2); }} aria-label="แพทย์เรียกคิว" size="large" color="c_button"
                                {...(queuePage === 2 && sxBtnSelectB)}
                            >
                                <AiOutlineOrderedList/>
                            </IconButton>
                        </Tooltip>

                    </Box>
                }

            </Box>

            {location.state.value === 0 && <AppointmentPatients value={appointPage}/>}
            {location.state.value === 1 && <AddAppointment />}
            {location.state.value === 2 && <TabQueueSystem value={queuePage}/>}

        </>
    )
}